/**
 * Resolves the first valid viewer route for a study (same rules as WorkList expanded actions).
 */
export function getStudyViewerHref({
  study,
  appConfig,
  dataPath,
  filterValues,
  preserveQueryParameters,
}: {
  study: { studyInstanceUid: string; modalities?: string };
  appConfig: {
    groupEnabledModesFirst?: boolean;
    loadedModes: Array<{
      displayName?: string;
      routeName: string;
      isValidMode: (args: { modalities: string; study: unknown }) => { valid: boolean };
    }>;
  };
  dataPath: string;
  filterValues: { configUrl?: string };
  preserveQueryParameters: (q: URLSearchParams) => void;
}): string | null {
  const modalities = (study.modalities || '').replaceAll('/', '\\');
  const modes = appConfig.groupEnabledModesFirst
    ? [...appConfig.loadedModes].sort((leftMode, rightMode) => {
        const leftValid = leftMode.isValidMode({ modalities, study }).valid;
        const rightValid = rightMode.isValidMode({ modalities, study }).valid;
        return Number(rightValid) - Number(leftValid);
      })
    : appConfig.loadedModes;

  for (const mode of modes) {
    const { valid } = mode.isValidMode({
      modalities,
      study,
    });
    if (valid && mode.displayName) {
      const query = new URLSearchParams();
      if (filterValues.configUrl) {
        query.append('configUrl', filterValues.configUrl);
      }
      query.append('StudyInstanceUIDs', study.studyInstanceUid);
      preserveQueryParameters(query);
      return `${mode.routeName}${dataPath || ''}?${query.toString()}`;
    }
  }
  return null;
}
